<script setup lang="ts">
import ButtonComponent from "@components/button.vue";
import { Link } from "@inertiajs/vue3";
import { trans } from 'laravel-vue-i18n';
import { ref, onMounted, onUnmounted } from "vue";

const videoRef = ref<HTMLVideoElement | null>(null);

const handleIntersection = (entries: IntersectionObserverEntry[]) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            videoRef.value?.play();
        } else {
            videoRef.value?.pause();
        }
    });
};

onMounted(() => {
    const observer = new IntersectionObserver(handleIntersection, {
        threshold: 0.5,
    });
    if (videoRef.value) {
        observer.observe(videoRef.value);
    }
    onUnmounted(() => {
        observer.disconnect();
    });
});

</script>

<template>
    <section id="home-section-hero">
        <div class="container p-0">
            <div class="inner-hero">
                <h1 v-html="trans('pages.home.title')"></h1>
                <p class="text-black">{{ trans('pages.home.description') }}</p>
                <p class="relative" v-if="new Date().getMonth() === 1 && new Date().getDate() >= 11 && new Date().getDate() <= 17">
                    <i class="heart fa-solid fa-heart fa-beat"></i>
                    <span class="tooltip underline" :data-tip="trans('pages.home.promo_tip')">{{ trans('pages.home.promo') }}</span>: {{ trans('pages.home.promo_desc') }}
                </p>
                <div class="button-container">
                    <p>{{ trans('pages.home.design_button_desc') }}</p>
                    <Link :href="route('preconfig.all')">
                        <button-component color="dark-slate">
                            {{ trans('pages.home.product_button') }}
                        </button-component>
                    </Link>
                </div>
            </div>

            <div class="hero-video">
                <video
                    preload="none"
                    playsinline
                    autoplay
                    muted
                    src="/videos/render-hd.webm?v=2"
                    width="100%"
                    height="1442"
                    ref="videoRef"
                ></video>
            </div>
        </div>
    </section>
</template>
<style scoped lang="scss">
@use "@scss/pages/home/sections/hero";
</style>
